import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { TOption } from '../../ui';
import { map as lmap, isEmpty } from 'lodash';
import { Share, SLMovementLineShareType, slMovementLineShareTypes } from './movement';
import { SLMovementLineShareTypePipe } from './movement-line-share-type.pipe';
import { SLEntity } from './entity';
import { validateAmount } from './movement-edit.component';
import { FormControl } from '@angular/forms';
import JSBI from 'jsbi';

export interface SLMovementDismembermentParams {
  amount: Share,
  shareType: SLMovementLineShareType
  sourceEntity: SLEntity
  destEntity: SLEntity
}

@Component({
  templateUrl: './movement-dismemberment-dialog.component.html',
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-306px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class SLMovementDismembermentDialogComponent implements Dialog, OnInit {
  state = 'closed';

  hideId: string

  amount: FormControl
  sourceEntity: FormControl
  destEntity: FormControl

  @ViewChild('amountInput')
  amountInput: ElementRef

  movementLineShareTypeOptions: TOption[] = lmap(slMovementLineShareTypes(), (value: SLMovementLineShareType) => ({
    value,
    text: new SLMovementLineShareTypePipe().transform(value),
  }));

  model: SLMovementDismembermentParams = {
    sourceEntity: null,
    destEntity: null,
    amount: null,
    shareType: 'ORD',
  }
   
  
  onClose: () => void
  onApply: (filter: SLMovementDismembermentParams) => void

  ngOnInit() {
    // Amount
    const amount = new FormControl(null, [validateAmount]);

    amount.valueChanges.subscribe((value) => {
      if (amount.valid) {
        this.model.amount = JSBI.BigInt(value);
      }
      else {
        this.model.amount = JSBI.BigInt(0);
      }
    });

    this.amount = amount;

    //  Source entity
    this.sourceEntity = new FormControl(this.model.sourceEntity);
    this.sourceEntity.valueChanges.subscribe((value) => { this.model.sourceEntity = value });

    //  Dest entity
    this.destEntity = new FormControl(this.model.destEntity);
    this.destEntity.valueChanges.subscribe((value) => { this.model.destEntity = value });

    // Focus amount input
    this.amountInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  apply() {
    this.onApply(this.model);
  }

  get isValid() {
    return !isEmpty(this.model.sourceEntity)
      && !isEmpty(this.model.destEntity)
      && this.model.sourceEntity !== this.model.destEntity
      && this.model.amount;
  }
}

